import { useInput } from "@redotech/react-util/form";
import { useHandler } from "@redotech/react-util/hook";
import { useLoad } from "@redotech/react-util/load";
import { useContext, useState } from "react";
import { useParams } from "react-router-dom";
import { RedoAdminRpcClientContext } from "../../../app/redo-admin-rpc-client-provider";
import {
  fedexEasyReturnsDefault,
  fedexEasyReturnsForm,
  FedexEasyReturnsValue,
} from "./fedex-easy-returns-settings";

export function useBlueYonder() {
  const { teamId } = useParams();
  const rpcClient = useContext(RedoAdminRpcClientContext);

  const [fedexEasyReturnsSettings, setFedexEasyReturnsSettings] =
    useState<FedexEasyReturnsValue | null>(null);

  const fetchAndSaveSettings = useHandler(async (signal: AbortSignal) => {
    if (!teamId) {
      return;
    }
    const integration = await rpcClient?.getBlueYonderUpcharge(
      { teamId },
      { signal },
    );

    if (!integration?.hasIntegration) {
      return null;
    }

    const formattedSettings: FedexEasyReturnsValue = {
      upcharge: String(integration.upcharge ?? 0),
    };
    setFedexEasyReturnsSettings(formattedSettings);
    fedexEasyReturnsInput.setValue(formattedSettings);

    return formattedSettings;
  });

  const fedexEasyReturnsSettingsLoad = useLoad(
    async (signal) => {
      return await fetchAndSaveSettings(signal);
    },
    [fetchAndSaveSettings],
  );

  const fedexEasyReturnsInput = useInput(
    fedexEasyReturnsForm,
    fedexEasyReturnsSettings || fedexEasyReturnsDefault,
  );

  const save = useHandler(async (signal: AbortSignal) => {
    if (!teamId) {
      return;
    }
    await rpcClient?.updateBlueYonderUpcharge({
      teamId,
      upcharge: Number(fedexEasyReturnsInput.value.upcharge),
    });
    await fetchAndSaveSettings(signal);
  });

  return { fedexEasyReturnsSettingsLoad, save, fedexEasyReturnsInput };
}
